/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskSignalsGet } from "../funcs/riskSignalsGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskSignalsResult } from "../models/components/risksignalsresult.js";
import {
  GetRiskSignalsRequest,
  GetRiskSignalsSecurity,
} from "../models/operations/getrisksignals.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskSignalsQueryData = RiskSignalsResult;

export function prefetchRiskSignals(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetRiskSignalsRequest | undefined,
  security?: GetRiskSignalsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskSignalsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskSignalsQuery(
  client$: GramCore,
  request?: GetRiskSignalsRequest | undefined,
  security?: GetRiskSignalsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<RiskSignalsQueryData>;
} {
  return {
    queryKey: queryKeyRiskSignals({
      from: request?.from,
      to: request?.to,
      mcpServerId: request?.mcpServerId,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskSignalsQueryFn(
      ctx,
    ): Promise<RiskSignalsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskSignalsGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskSignals(
  parameters: {
    from?: Date | undefined;
    to?: Date | undefined;
    mcpServerId?: string | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "signals", "get", parameters];
}
